// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b7c49df5","325":"75c4b6b7","394":"4c5b7d67","440":"13754338","449":"63c29912","585":"bed72f92","681":"0fa637d1"}[chunkId] + ".chunk.js";
};